import * as yup from "yup";

export const SupplierFormSchema = yup.object().shape({
    companyName: yup.string().required().label("Company Name"),
    averageSpend: yup.number().required().label("Average Monthly Spend"),
    contactName: yup.string().required().label("Contact Name"),
    phone: yup.string().required().label("Phone"),
    email: yup.string().email().required().label("Email")
});
